module.exports = __webpack_public_path__ + "img/map3_seo.ff0883f0.jpg";